import { NgModule } from '@angular/core';
import { PagePerformanceAdminModule } from './admin/admin.module';

@NgModule({
    imports: [PagePerformanceAdminModule],
})
export class PagePerformancePagesModule {}
